import React from 'react';
import { Box, Typography, Grid, Button } from '@mui/material';
import goldMedal from '../../../../assets/logos/gold_seal.webp';
import { Link } from 'react-router-dom';
import { HOMEOWNER_PORTAL_ROUTES } from '../../routes';

export const ReferralProgramSection = () => {
  return (
    <Box
      sx={{
        backgroundColor: 'backgroundBlue.main',
        py: { xs: 2, md: 4 },
        px: { xs: 2, md: 4 },
        mb: { xs: 6, md: 10 }
      }}
    >
      <Grid container spacing={4} alignItems="center">
        <Grid item xs={12} md={7}>
          <Typography
            variant="h4"
            sx={{
              mb: 0.75
            }}
          >
            Homeowner Referral Program
          </Typography>

          <Typography
            variant="body1"
            sx={{
              mb: 3
            }}
          >
            Share the joy of homeownership.
          </Typography>

          <Typography
            variant="body1"
            sx={{
              mb: 4
            }}
          >
            Your referral means the world to us! Introduce someone to Stone Martin Builders, and
            when they close on their dream home, you'll receive a ---- as a heartfelt thank-you.
          </Typography>

          <Button
            variant="contained"
            sx={{
              width: { xs: '100%', md: '225px' }
            }}
            component={Link}
            to={HOMEOWNER_PORTAL_ROUTES.REFERRAL}
          >
            Refer a friend!
          </Button>
        </Grid>

        <Grid item xs={12} md={5}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%'
            }}
          >
            <img
              src={goldMedal}
              alt="Referral Program Badge"
              style={{
                maxWidth: '100%',
                height: 'auto',
                maxHeight: '250px'
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
